import React, { useState } from 'react';
import { Mail, MapPin, Phone, Send } from 'lucide-react';
import { mockData } from '../mock';
import emailjs from 'emailjs-com';

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    product: '',
    quantity: '',
    message: ''
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('Form submitted:', formData);
    // setIsSubmitted(true);
    // // Reset form after 3 seconds
    // setTimeout(() => {
    //   setIsSubmitted(false);
    //   setFormData({
    //     name: '',
    //     company: '',
    //     email: '',
    //     phone: '',
    //     product: '',
    //     quantity: '',
    //     message: ''
    //   });
    // }, 3000);

    e.preventDefault();

  emailjs.send(
    'service_z16l8e4',
    'template_iwy8f5p',
    formData,
    'Y_upRZ30WcJALi5LV'
  )
  .then(() => {
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        product: '',
        quantity: '',
        message: ''
      });
    }, 3000);
  })
  .catch((error) => {
    console.error('Email sending failed:', error);
    alert('Failed to send message, please try again later.');
  });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-content">
          {/* Contact Info */}
          <div className="contact-info">
            <h2 className="heading-1 mb-4">Get Your Quote Today</h2>
            <p className="body-large mb-8">
              Ready to source premium guar gum for your business? Contact our expert team for competitive pricing and technical support.
            </p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <Mail className="contact-icon" size={20} />
                <div>
                  <div className="contact-label">Email us at</div>
                  <div className="contact-value">{mockData.company.email}</div>
                </div>
              </div>
              
              <div className="contact-method">
                <Phone className="contact-icon" size={20} />
                <div>
                  <div className="contact-label">Phone Numbers</div>
                  <div className="contact-value">{mockData.company.phones.usa} (USA)</div>
                  <div className="contact-value">{mockData.company.phones.india} (India)</div>
                </div>
              </div>
              
              <div className="contact-method">
                <MapPin className="contact-icon" size={20} />
                <div>
                  <div className="contact-label">USA Office</div>
                  <div className="contact-value">
                    {mockData.company.addresses.usa.street}<br/>
                    {mockData.company.addresses.usa.suite}<br/>
                    {mockData.company.addresses.usa.city}, {mockData.company.addresses.usa.state} {mockData.company.addresses.usa.zip}
                  </div>
                </div>
              </div>
              
              <div className="contact-method">
                <MapPin className="contact-icon" size={20} />
                <div>
                  <div className="contact-label">India Office</div>
                  <div className="contact-value">
                    {mockData.company.addresses.india.street}<br/>
                    {mockData.company.addresses.india.city}, {mockData.company.addresses.india.district}<br/>
                    {mockData.company.addresses.india.state} {mockData.company.addresses.india.pin}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="response-time">
              <h3 className="heading-3 mb-2">Quick Response</h3>
              <p className="body-medium">
                We respond to all inquiries within 24 hours. For urgent requests, please mention it in your message.
              </p>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="contact-form-container">
            {!isSubmitted ? (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h3 className="heading-3 mb-6">Request a Quote</h3>
                
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Company *</label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Phone</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Product Grade *</label>
                    <select
                      name="product"
                      value={formData.product}
                      onChange={handleChange}
                      className="form-input"
                      required
                    >
                      <option value="">Select Product Grade</option>
                      <option value="food-grade">Food Grade Guar Gum</option>
                      <option value="industrial-grade">Industrial Grade Guar Gum</option>
                      <option value="pharmaceutical-grade">Pharmaceutical Grade</option>
                      <option value="custom">Custom Specifications</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Quantity (kg/month)</label>
                    <input
                      type="text"
                      name="quantity"
                      value={formData.quantity}
                      onChange={handleChange}
                      className="form-input"
                      placeholder="e.g., 1000"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label className="form-label">Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    placeholder="Please describe your specific requirements, application, and any technical specifications needed."
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn-cta w-full">
                  <Send size={20} />
                  Send Quote Request
                </button>
              </form>
            ) : (
              <div className="success-message">
                <div className="success-icon">
                  <Send size={48} />
                </div>
                <h3 className="heading-3 mb-4">Quote Request Sent!</h3>
                <p className="body-medium">
                  Thank you for your interest in our guar gum products. Our team will review your requirements and respond within 24 hours with a detailed quote.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Styles
const styles = `
.contact-section {
  background: var(--bg-subtle);
  padding: var(--spacing-giant) 0;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-giant);
  max-width: 1200px;
  margin: 0 auto;
}

.contact-info {
  padding-right: var(--spacing-medium);
}

.contact-methods {
  margin-bottom: var(--spacing-xl);
}

.contact-method {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: var(--spacing-medium);
}

.contact-icon {
  color: var(--brand-dark);
  background: var(--brand-primary);
  padding: 8px;
  border-radius: 8px;
  flex-shrink: 0;
}

.contact-label {
  font-size: 14px;
  color: var(--text-light);
  font-weight: 500;
}

.contact-value {
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 600;
}

.response-time {
  background: white;
  padding: var(--spacing-medium);
  border-radius: 20px;
  border: 1px solid var(--border-light);
}

.contact-form-container {
  background: white;
  padding: var(--spacing-xl);
  border-radius: 32px;
  box-shadow: 0 4px 16px rgba(0, 69, 52, 0.1);
  border: 1px solid var(--border-light);
}

.contact-form {
  width: 100%;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-medium);
  margin-bottom: var(--spacing-medium);
}

.form-group {
  margin-bottom: var(--spacing-medium);
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.success-message {
  text-align: center;
  padding: var(--spacing-xl) 0;
}

.success-icon {
  background: var(--brand-primary);
  color: var(--brand-dark);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--spacing-medium);
}

.w-full {
  width: 100%;
}

.btn-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

@media (max-width: 1024px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: var(--spacing-xl);
  }
  
  .contact-info {
    padding-right: 0;
  }
}

@media (max-width: 781px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .contact-form-container {
    padding: var(--spacing-medium);
  }
  
  .contact-method {
    margin-bottom: var(--spacing-small);
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}